import * as React from "react";
import { createRoot } from "react-dom/client";
import { Routes, Route } from "react-router-dom";

import { HeaderNav } from "./components/HeaderNav";
import { MantineProvider } from "@mantine/core";
import { NotFoundPage } from "./components/NotFoundPage";
import { AboutPage } from "./pages/about/AboutPage";

import { SamplePage } from "./pages/samples/SamplePage";
import SampleDetailPage from "./pages/samples/SampleDetailPage";

export default function App() {
  return (
    <>
      <MantineProvider
        theme={{
          fontFamily: "IM Fell English, serif",
          fontFamilyMonospace: "IM Fell English, serif",
          headings: { fontFamily: "IM Fell English, serif" },
          // colors: {
          //   brand: ["#144eff", "#144eff", "#144eff", "#144eff", "#144eff", "#144eff", "#144eff", "#144eff", "#144eff", "#144eff"],
          // },
          // primaryColor: "brand",
        }}
        // children={undefined}
      >
        <HeaderNav />

        <Routes>
          <Route path="/" element={<SamplePage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="/stamp/:id" element={<SampleDetailPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </MantineProvider>
    </>
  );
}

export function renderToDom(container) {
  createRoot(container).render(<App />);
}
